const windWidth = window.innerWidth || 1000
export const randomX = () => Math.random() * windWidth - windWidth / 5
 